module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fs",
    attrs: {
      "id": "page019"
    }
  }, [_c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page019_1"
    }
  }, [_vm._v("5.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page019_1a"
    }
  }, [_c('span', {
    staticClass: "page019_1a"
  }, [_vm._v("Roll out the dough into a 30-cm-diameter circle. Cut the circle")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page019_2"
    }
  }, [_vm._v("into 8 wedges (like pizza slices). Put 1 teaspoon of apricot jam in")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page019_3"
    }
  }, [_vm._v("the centre of a wedge and roll it up from the bottom, turning the")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page019_4"
    }
  }, [_vm._v("pointed sides slightly inwards. Tuck the end under the croissant,")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page019_5"
    }
  }, [_vm._v("pressing firmly, to prevent it from coming loose while baking.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page019_6"
    }
  }, [_vm._v("Rest the croissants 2-3 hours on a baking tray lined with baking")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page019_7"
    }
  }, [_vm._v("parchment.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page019_8"
    }
  }, [_vm._v("6.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page019_8a"
    }
  }, [_c('span', {
    staticClass: "page019_8a"
  }, [_vm._v(" Preheat the oven to 180°C/350°F/gas 4. Brush the croissants")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page019_9"
    }
  }, [_vm._v("with a little vegan cream to give them a nice golden colour when")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page019_10"
    }
  }, [_vm._v("baked. Bake for 20–25 minutes on the middle shelf, until golden.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ee16d9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_019.vue
// module id = 111
// module chunks = 0